import {
  ADD_OPTIONS_FOR_POLL,
  ADD_QUESTION_FOR_POLL,
  ADD_DESCRIPTION_FOR_POLL,
  ADD_DATE_FOR_POLL,
  ADD_TAGS_FOR_POLL,
  TOGGLE_IS_ANSWER_FOR_POLL,
  ADD_CATEGORY,
  ADD_QUESTION,
  ADD_DESCRIPTION,
  ADD_DATE,
  ADD_TAGS,
  ADD_CATEGORY_QUESTION,
  IS_ANSWER,
  ADD_QUESTION_BLOGS,
  ADD_DESCRIPTION_BLOGS,
  ADD_DATE_BLOGS,
  ADD_TAGS_BLOGS,
  ADD_CATEGORY_BLOGS,
  ADD_COMMENTS_BLOGS,
  ADD_CATEGORY_BLOGS_STATUS,
  ADD_CATEGORY_QUESTION_STATUS,
  ADD_BLOG_CONTENT,
  ADD_BLOG_COVER_IMAGE,
  GET_CATEGORY_FROM_API,
  FETCH_CATEGORY_FROM_API,
  GET_CATEGORY_FROM_API_QUESTION,
  IS_FETCH_CATEGORY_FROM_API,
  REMOVE_BLOG_COVER_IMAGE,
  ADD_QUESTION_COVER_IMAGE,
  REMOVE_QUESTION_COVER_IMAGE,
  GET_SINGLE_POST_DATAS,
  IS_SINGLE_POST_DATA_FETCH,
  EDIT_QUESTION_BLOGS,
  EDIT_DESCRIPTION_BLOGS,
  EDIT_BLOG_CONTENT,
  EDIT_IS_COMMENT,
  EDIT_TAGS_BLOGS,
  REMOVE_HEAD_IMAGE_BLOGS,
  EDIT_HEAD_IMAGE_BLOGS,
  FETCH_CATEGORY_FROM_API_EDIT,
  EDIT_CATEGORY_BLOGS_STATUS,
  EMPTY_BLOG_EDIT_STATE,
  GET_SINGLE_QUESTION_DATA,
  EDIT_QUESTION,
  EDIT_DESCRIPTION_QUESTION,
  EDIT_IS_ANSWER,
  EDIT_TAGS_QUESTION,
  REMOVE_HEAD_IMAGE_QUESTION,
  EDIT_HEAD_IMAGE_QUESTION,
  FETCH_CATEGORY_FROM_API_EDIT_QUESTION,
  EDIT_CATEGORY_QUESTION_STATUS,
  SET_MASTER_DATA,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_USER_NAME,
  SET_EMAIL,
  SET_PHONE,
  SET_WEBSITE,
  SET_BIO,
  SET_FB,
  SET_INSTA,
  SET_LINKIN,
  SET_TWI,
  SET_YT,
  SET_BE,
  SET_DRIBBLE,
  SET_PIN,
  SET_DOB,
  SET_GENDER,
  SET_COUNTRY,
  SET_STATE,
  SET_CITY,
  SET_PINCODE,
  SET_IS_PROFILE_LOADER,
  SET_IS_PROFILE_PIC,
  SET_IS_BANNER_PIC,
  IS_FETCHED_BLOG,
  IS_FETCHED_QUESTION,
  RESET_BLOG_CONTENT,
  RESET_QUESTION_CONTENT,
  SET_USER,
  NOTIFICATION_DATA,
  NOTIFICATION_UPDATE,
  FETCH_CATEGORY,
  CLEAR_IMAGE_BLOG,
  IS_MOBILE_SEARCH,
  SET_RESUME_DATA,
  ADD_SKILLS,
  ADD_SKILLS_TITLE,
  ADD_SKILLS_RANGE,
  SKILLS_RESET,
  SKILLS_DELETE,
  CHECK_PROFILE,
  CHECK_BIO,
  CHECK_FULLNAME,
  CHECK_ADDRESS,
  CHECK_PHONE,
  CHECK_EMAIL,
  CHECK_FB,
  CHECK_LINKD,
  CHECK_TW,
  CHECK_DRIBBLE,
  CHECK_BE,
  CHECK_PIN,
  CHECK_INSTA,
  CHECK_YT,
  CHECK_EDUCATION,
  CHECK_WORK,
  CHECK_PUBLIC,
  CHECK_CERT,
  CHECK_EXTRA,
  CHECK_PROJECT,
  CHECK_ALL_PERSONAL_DETAIL,
  CHECK_ALL_EDUCATION,
  CHECK_ALL_WORK,
  CHECK_ALL_PUBLICATION,
  CHECK_ALL_PROJECT,
  GET_RESUME_DATA,
  UNCHECK_ALL_PERSONAL_DETAIL,
  ADD_HOBBIES,
  EDIT_HOBBIES,
  DELETE_HOBBIES,
  EDIT_SKILLS,
  DELETE_SKILLS,
  SET_LANGUAGES,
  REMOVE_LANGUAGES,
  SET_HOBBILES_IMAGE,
  CHECK_ALL_CERTIFICATE,
  CHECK_ALL_EXTRA, //new from here
  GET_ENTIRE_USER_DATA_RESUME,
  SET_TITLE_RESUME,
  ADD_SKILL,
  UPDATE_SKILL,
  DELETE_SKILL,
  ADD_HOBBY,
  UPDATE_HOBBY,
  DELETE_HOBBY,
  PHOTO_PRIVACY,
  CERTIFICATE_PRIVACY,
  EDUCATION_PRIVACY,
  WORK_PRIVACY,
  PROJECT_PRIVACY,
  PUBLICATION_PRIVACY,
  ORENTATION_RESUME,
  BACKGROUND_RESUME
} from "../constants";

export const handleQuestionForPoll = (value) => {
  return {
    type: ADD_QUESTION_FOR_POLL,
    payload: { value },
  };
};
export const handleDescriptionForPoll = (value) => {
  return {
    type: ADD_DESCRIPTION_FOR_POLL,
    payload: { value },
  };
};
export const handleDateForPoll = (value) => {
  return {
    type: ADD_DATE_FOR_POLL,
    payload: { value },
  };
};
export const handleTagsForPoll = (value) => {
  return {
    type: ADD_TAGS_FOR_POLL,
    payload: { value },
  };
};
export const handleIsAnswerForPoll = () => {
  return {
    type: TOGGLE_IS_ANSWER_FOR_POLL
  };
};
export const addCategories = (value) => {
  return {
    type: ADD_CATEGORY,
    payload: { value },
  };
};
export const handleAddOptionsForPoll = () => {
  return {
    type: ADD_OPTIONS_FOR_POLL,
    payload: "Mukesh",
  };
};


// QUESTION 
export const handleQuestion = (value) => {
  return {
    type: ADD_QUESTION,
    payload: { value },
  };
}
export const handleDescription = (value) => {
  return {
    type: ADD_DESCRIPTION,
    payload: { value },
  };
}
export const handleDate = (value) => {
  return {
    type: ADD_DATE,
    payload: { value },
  };
}
export const handleTags = (value) => {
  return {
    type: ADD_TAGS,
    payload: { value },
  };
};
export const handleCategory = (value) => {
  return {
    type: ADD_CATEGORY_QUESTION,
    payload: { value },
  };
};
export const isAnswerHandle = () => {
  return {
    type: IS_ANSWER,
  };
};
export const addQuestionCategoryCheck = (idx, value, bool) => {
  return {
    type: ADD_CATEGORY_QUESTION_STATUS,
    payload: { idx, value, bool },
  };
};
export const getCategoryQuestion = (value) => {
  return {
    type: GET_CATEGORY_FROM_API_QUESTION,
    payload: value,
  }
};
export const fetchCategoryFromApiQuestion = () => {
  return {
    type: IS_FETCH_CATEGORY_FROM_API,
    payload: '',
  }
};
export const addQuestionCoverImage = (e) => {
  return {
    type: ADD_QUESTION_COVER_IMAGE,
    payload: e,
  }
};
export const removeQuestionHeadImage = () => {
  return {
    type: REMOVE_QUESTION_COVER_IMAGE,
    payload: '',
  }
};

// BLOGS
export const handleQuestionForBlogs = (value) => {
  return {
    type: ADD_QUESTION_BLOGS,
    payload: { value },
  };
};
export const handleDescriptionForBlogs = (value) => {
  return {
    type: ADD_DESCRIPTION_BLOGS,
    payload: { value },
  };
};
export const handleDateForBlogs = (value) => {
  return {
    type: ADD_DATE_BLOGS,
    payload: { value },
  };
};
export const handleTagsForBlogs = (value) => {
  return {
    type: ADD_TAGS_BLOGS,
    payload: { value },
  };
};
export const handleCategoryForBlogs = (value) => {
  return {
    type: ADD_CATEGORY_BLOGS,
    // payload: {value},
  };
};
export const commentsOnForBlog = (value) => {
  return {
    type: ADD_COMMENTS_BLOGS,
    payload: { value },
  };
};
export const addCategoryCheck = (idx, value, bool) => {
  return {
    type: ADD_CATEGORY_BLOGS_STATUS,
    payload: { idx, value, bool },
  };
};
export const addBlogContent = (value) => {
  return {
    type: ADD_BLOG_CONTENT,
    payload: { value },
  };
};
export const addBlogCoverImage = (e) => {
  return {
    type: ADD_BLOG_COVER_IMAGE,
    payload: e,
  }
};
export const getCategory = (value) => {
  return {
    type: GET_CATEGORY_FROM_API,
    payload: value,
  }
};
export const fetchCategoryFromApi = () => {
  return {
    type: FETCH_CATEGORY_FROM_API,
    payload: '',
  }
};
export const removeBlogHeadImage = () => {
  return {
    type: REMOVE_BLOG_COVER_IMAGE,
    payload: '',
  }
};
export const setSinglePostData = (value) => {
  return {
    type: GET_SINGLE_POST_DATAS,
    payload: value,
  }
};
export const isSinglePostDataFetched = (value) => {
  return {
    type: IS_SINGLE_POST_DATA_FETCH,
    payload: value,
  }
};
export const editTitleBlogs = (value) => {
  return {
    type: EDIT_QUESTION_BLOGS,
    payload: value,
  }
};
export const editDescriptionBlogs = (value) => {
  return {
    type: EDIT_DESCRIPTION_BLOGS,
    payload: value,
  }
};
export const editContentBlogs = (value) => {
  return {
    type: EDIT_BLOG_CONTENT,
    payload: value,
  }
};
export const editCommentBlogs = () => {
  return {
    type: EDIT_IS_COMMENT,
    payload: '',
  }
};
export const editTagsBlogs = (value) => {
  return {
    type: EDIT_TAGS_BLOGS,
    payload: value,
  }
};
export const removeEditHeadImageBlogs = (value) => {
  return {
    type: REMOVE_HEAD_IMAGE_BLOGS,
    payload: value,
  }
};
export const editHeadImageBlogs = (e) => {
  return {
    type: EDIT_HEAD_IMAGE_BLOGS,
    payload: e,
  }
};
export const fetchCategoryFromApiEdit = (value) => {
  return {
    type: FETCH_CATEGORY_FROM_API_EDIT,
    payload: value,
  }
};
export const editCategoryCheck = (idx, value, bool) => {
  return {
    type: EDIT_CATEGORY_BLOGS_STATUS,
    payload: { idx, value, bool },
  };
};
export const cleanUpBlogState = () => {
  return {
    type: EMPTY_BLOG_EDIT_STATE,
    payload: '',
  };
};


// QUESTION EDIT STARTS
export const setSingleQuestionData = (value) => {
  return {
    type: GET_SINGLE_QUESTION_DATA,
    payload: value,
  }
};
export const editQuestion = (value) => {
  return {
    type: EDIT_QUESTION,
    payload: value,
  }
};
export const editDescriptionQuestion = (value) => {
  return {
    type: EDIT_DESCRIPTION_QUESTION,
    payload: value,
  }
};
export const editIsAnswer = () => {
  return {
    type: EDIT_IS_ANSWER,
    payload: '',
  }
};
export const editTagsQuestion = (value) => {
  return {
    type: EDIT_TAGS_QUESTION,
    payload: value,
  }
};
export const removeEditHeadImageQuestion = () => {
  return {
    type: REMOVE_HEAD_IMAGE_QUESTION,
    payload: '',
  }
};
export const editHeadImageQuestion = (e) => {
  return {
    type: EDIT_HEAD_IMAGE_QUESTION,
    payload: e,
  }
};
export const fetchCategoryFromApiEditQuestion = (value) => {
  return {
    type: FETCH_CATEGORY_FROM_API_EDIT_QUESTION,
    payload: value,
  }
};
export const editCategoryCheckQuestion = (idx, value, bool) => {
  return {
    type: EDIT_CATEGORY_QUESTION_STATUS,
    payload: { idx, value, bool },
  };
};
// QUESTION EDITS ENDS


export const setMasterData = (value) => {
  return {
    type: SET_MASTER_DATA,
    payload: value,
  };
};

// ACCOUNT UPDATE
export const editFirstName = (value) => {
  return {
    type: SET_FIRST_NAME,
    payload: value,
  };
}
export const editLastName = (value) => {
  return {
    type: SET_LAST_NAME,
    payload: value,
  };
}
export const editUserName = (value) => {
  return {
    type: SET_USER_NAME,
    payload: value,
  };
}
export const editEmail = (value) => {
  return {
    type: SET_EMAIL,
    payload: value,
  };
}
export const editPhone = (value) => {
  return {
    type: SET_PHONE,
    payload: value,
  };
}
export const editWebsite = (value) => {
  return {
    type: SET_WEBSITE,
    payload: value,
  };
}
export const editBio = (value) => {
  return {
    type: SET_BIO,
    payload: value,
  };
}
export const editFb = (value) => {
  return {
    type: SET_FB,
    payload: value,
  };
}
export const editInsta = (value) => {
  return {
    type: SET_INSTA,
    payload: value,
  };
}
export const editLinkIn = (value) => {
  return {
    type: SET_LINKIN,
    payload: value,
  };
}
export const editTwi = (value) => {
  return {
    type: SET_TWI,
    payload: value,
  };
}
export const editYt = (value) => {
  return {
    type: SET_YT,
    payload: value,
  };
}
export const editBe = (value) => {
  return {
    type: SET_BE,
    payload: value,
  };
}
export const editDrib = (value) => {
  return {
    type: SET_DRIBBLE,
    payload: value,
  };
}
export const editPin = (value) => {
  return {
    type: SET_PIN,
    payload: value,
  };
}
export const editDOB = (value) => {
  return {
    type: SET_DOB,
    payload: value,
  };
}
export const editGender = (value) => {
  return {
    type: SET_GENDER,
    payload: value,
  };
}
export const editCountry = (value) => {
  return {
    type: SET_COUNTRY,
    payload: value,
  };
}
export const editState = (value) => {
  return {
    type: SET_STATE,
    payload: value,
  };
}
export const editCity = (value) => {
  return {
    type: SET_CITY,
    payload: value,
  };
}
export const editPincode = (value) => {
  return {
    type: SET_PINCODE,
    payload: value,
  };
}
export const userProfileLoaded = (value) => {
  return {
    type: SET_IS_PROFILE_LOADER,
    payload: value
  };
}
export const userProfilePic = (file) => {
  return {
    type: SET_IS_PROFILE_PIC,
    payload: file
  };
}
export const userBannerPic = (file) => {
  return {
    type: SET_IS_BANNER_PIC,
    payload: file
  };
}
export const setLanguages = (value) => {
  return {
    type: SET_LANGUAGES,
    payload: value
  };
}
export const removeLanguages = (value) => {
  return {
    type: REMOVE_LANGUAGES,
    payload: value
  };
}


// EDIT BLOG
export const isFetchedBlog = (value) => {
  return {
    type: IS_FETCHED_BLOG,
    payload: value,
  };
}
export const isFetchedQuestion = (value) => {
  return {
    type: IS_FETCHED_QUESTION,
    payload: value,
  };
}
export const resetBlogContent = (value) => {
  return {
    type: RESET_BLOG_CONTENT,
    payload: value,
  };
}
export const resetQuestionContent = (value) => {
  return {
    type: RESET_QUESTION_CONTENT,
    payload: value,
  };
}
export const setUser = (value) => {
  return {
    type: SET_USER,
    payload: value,
  };
}

export const notificationData = (value) => {
  return {
    type: NOTIFICATION_DATA,
    payload: value
  };
};
export const notificationUpdate = (value) => {
  return {
    type: NOTIFICATION_UPDATE,
    payload: value
  };
};
export const fetchCategory = (value) => {
  return {
    type: FETCH_CATEGORY,
    payload: value
  };
};
export const clearImageBlog = () => {
  return {
    type: CLEAR_IMAGE_BLOG,
  };
};
export const isMobileSearch = (value) => {
  return {
    type: IS_MOBILE_SEARCH,
    payload: value
  };
};


// RESUME
export const setResumeDataEdit = (value) => {
  return {
    type: GET_RESUME_DATA,
    payload: value
  }
}
// export const addSkills = () => {
//   return {
//     type: ADD_SKILLS
//   }
// }
export const addSkillsTitle = (id, value) => {
  return {
    type: ADD_SKILLS_TITLE,
    payload: { id, value }
  }
}
export const addSkillsRange = (id, value) => {
  return {
    type: ADD_SKILLS_RANGE,
    payload: { id, value }
  }
}
export const skillsReset = (id) => {
  return {
    type: SKILLS_RESET,
    payload: id
  }
}
export const skillsDelete = (id) => {
  return {
    type: DELETE_SKILLS,
    payload: id
  }
}

export const setResumeData = (value) => {
  return {
    type: SET_RESUME_DATA,
    payload: value
  }
}

export const checkProfile = () => {
  return {
    type: CHECK_PROFILE,
  }
}
export const checkBio = () => {
  return {
    type: CHECK_BIO,
  }
}
export const checkFullName = () => {
  return {
    type: CHECK_FULLNAME,
  }
}
export const checkAddress = () => {
  return {
    type: CHECK_ADDRESS,
  }
}
export const checkPhone = () => {
  return {
    type: CHECK_PHONE,
  }
}
export const checkEmail = () => {
  return {
    type: CHECK_EMAIL,
  }
}
export const checkFb = (status) => {
  return {
    type: CHECK_FB,
    payload: status
  }
}
export const checkLinkd = () => {
  return {
    type: CHECK_LINKD,
  }
}
export const checkTw = () => {
  return {
    type: CHECK_TW,
  }
}
export const checkDrib = () => {
  return {
    type: CHECK_DRIBBLE,
  }
}
export const checkBe = () => {
  return {
    type: CHECK_BE,
  }
}
export const checkPin = () => {
  return {
    type: CHECK_PIN,
  }
}
export const checkInsta = (status) => {
  console.log("status",status)
  return {
    type: CHECK_INSTA,
  }
}
export const checkYt = () => {
  return {
    type: CHECK_YT,
  }
}
export const checkEducation = (value) => {
  return {
    type: CHECK_EDUCATION,
    payload: value
  }
}
export const checkWork = (value) => {
  return {
    type: CHECK_WORK,
    payload: value
  }
}
export const checkPublic = (value) => {
  return {
    type: CHECK_PUBLIC,
    payload: value
  }
}
export const checkCert = (value) => {
  return {
    type: CHECK_CERT,
    payload: value
  }
}
export const checkExtra = (value) => {
  return {
    type: CHECK_EXTRA,
    payload: value
  }
}
export const checkProject = (value) => {
  return {
    type: CHECK_PROJECT,
    payload: value
  }
}
export const checkAllPersonalDetail = (action) => {
  return {
    type: CHECK_ALL_PERSONAL_DETAIL,
    payload: action
  }
}
export const checkAllEducation = (action) => {
  return {
    type: CHECK_ALL_EDUCATION,
    payload: action
  }
}
export const checkAllWork = (action) => {
  return {
    type: CHECK_ALL_WORK,
    payload: action
  }
}
export const checkAllPublication = (action) => {
  return {
    type: CHECK_ALL_PUBLICATION,
    payload: action
  }
}
export const checkAllCertificate = (action) => {
  return {
    type: CHECK_ALL_CERTIFICATE,
    payload: action
  }
}
export const checkAllExtra = (action) => {
  return {
    type: CHECK_ALL_EXTRA,
    payload: action
  }
}
export const checkAllProject = (action) => {
  return {
    type: CHECK_ALL_PROJECT,
    payload: action
  }
}
export const unCheckAllPersonalDetail = () => {
  return {
    type: UNCHECK_ALL_PERSONAL_DETAIL
  }
}
export const addHobbies = (value) => {
  return {
    type: ADD_HOBBIES,
    payload: value
  }
}
export const editHobbies = (id,value) => {
  return {
    type: EDIT_HOBBIES,
    payload: {id,value}
  }
}
export const deleteHobbies = (id) => {
  return {
    type: DELETE_HOBBIES,
    payload: id
  }
}
export const addSkills = (value) => {
  return {
    type: ADD_SKILLS,
    payload: value
  }
}
export const editSkills = (id,value) => {
  return {
    type: EDIT_SKILLS,
    payload: {id,value}
  }
}
export const setHobbiesImage = (value) => {
  return {
    type: SET_HOBBILES_IMAGE,
    payload: value
  }
}



// RESUME NEW

export const handleGetEntireUserDataResume = (value) => {
  return {
    type: GET_ENTIRE_USER_DATA_RESUME,
    payload: value ,
  };
};
export const handleAddSkill = (value) => {
  return {
    type: ADD_SKILL,
    payload: value,
  };
};
export const handleEditSkill = (value) => {
  return {
    type: UPDATE_SKILL,
    payload: value ,
  };
};
export const handleDeleteSkill = (value) => {
  return {
    type: DELETE_SKILL,
    payload: value ,
  };
};
export const handleAddHobby = (value) => {
  return {
    type: ADD_HOBBY,
    payload: value ,
  };
};
export const handleUpdateHobby = (value) => {
  return {
    type: UPDATE_HOBBY,
    payload: value ,
  };
};
export const handleDeleteHobby = (value) => {
  return {
    type: DELETE_HOBBY,
    payload: value ,
  };
};
export const handlePhotoPrivacyHobby = (value) => {
  return {
    type: PHOTO_PRIVACY,
    payload: value ,
  };
};
export const handleCertificatePrivacy = (value) => {
  return {
    type: CERTIFICATE_PRIVACY,
    payload: value ,
  };
};
export const handleEducationPrivacy = (value) => {
  return {
    type: EDUCATION_PRIVACY,
    payload: value ,
  };
};
export const handleWorkPrivacy = (value) => {
  return {
    type: WORK_PRIVACY,
    payload: value ,
  };
};
export const handleProjectPrivacy = (value) => {
  return {
    type: PROJECT_PRIVACY,
    payload: value ,
  };
};
export const handlePublicationPrivacy = (value) => {
  return {
    type: PUBLICATION_PRIVACY,
    payload: value ,
  };
};
export const handleOrentationResume = (value) => {
  return {
    type: ORENTATION_RESUME,
    payload: value ,
  };
};
export const handleBackgroundResume = (value) => {
  return {
    type: BACKGROUND_RESUME,
    payload: value ,
  };
};




// remove later
export const handleTitleResume = (value) => {
  return {
    type: SET_TITLE_RESUME,
    payload: value ,
  };
};

